/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/* eslint-disable no-plusplus */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import DashboardLayout from "pages/LayoutContainers/DashboardLayout";
import DashboardNavbar from "pages/Navbars/DashboardNavbar";
import useFetchWithMsal from "hooks/useFetchWithMsal";
import { protectedResources, siteData } from "authConfig";
import {
  Box,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteIcon from "@mui/icons-material/Delete";
import ArticleIcon from "@mui/icons-material/Article";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SaveIcon from "@mui/icons-material/Save";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDAlert from "components/MDAlert";
import GenerateReportDialog from "components/GenerateReportDialog";
import { useCurrentUser } from "context/UserContext";
import MDEditor from "@uiw/react-md-editor";
import "@uiw/react-md-editor/markdown-editor.css";

const REPORT_TYPE_LABELS = {
  strategic: "Board Paper",
  operational: "Watching Brief",
  tactical: "Action Report",
};

const LENGTH_PRESETS = [
  { label: "Half a page", value: "half a page" },
  { label: "One page", value: "1 page" },
  { label: "Two pages", value: "2 pages" },
  { label: "Three pages", value: "3 pages" },
  { label: "Five pages", value: "5 pages" },
];

const DEFAULT_PARAMS = {
  length: "2 pages",
  structure: "",
  includeCharts: false,
  scope: "watch-list",
  dateMode: "current",
  dateFrom: "",
  dateTo: "",
  forwardProjection: true,
};

function base64ToArrayBuffer(base64) {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes.buffer;
}

function triggerDocxDownload(base64, filename) {
  const ab = base64ToArrayBuffer(base64);
  const isPptx = String(filename || "")
    .toLowerCase()
    .endsWith(".pptx");
  const blob = new Blob([ab], {
    type: isPptx
      ? "application/vnd.openxmlformats-officedocument.presentationml.presentation"
      : "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

// ─── View Modal ───────────────────────────────────────────────────────────────

function ViewModal({ open, reportId, onClose, executeRef, isAdmin }) {
  const [loading, setLoading] = useState(false);
  const [docxBase64, setDocxBase64] = useState(null);
  const [llmContent, setLlmContent] = useState("");
  const [filename, setFilename] = useState("board-paper.docx");
  const [metadata, setMetadata] = useState(null);
  const [mode, setMode] = useState("view");
  const [editedContent, setEditedContent] = useState("");
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState(null);
  // Callback ref (not useRef): re-runs the render effect the moment the preview node mounts.
  // A plain ref doesn't retrigger the effect, so if docxBase64 committed while the container
  // was still absent (e.g. loading spinner up), the docx never rendered → blank grey pane.
  const [previewNode, setPreviewNode] = useState(null);
  const renderedBase64Ref = useRef(null);

  useEffect(() => {
    if (!open || !reportId) return;
    setLoading(true);
    setMode("view");
    setDocxBase64(null);
    setLlmContent("");
    setSaveError(null);
    executeRef
      .current("GET", `${protectedResources.apiTodoList.endpoint}/boardPaper/${reportId}/view`)
      .then((res) => {
        if (res?.success) {
          setDocxBase64(res.data.docxBase64);
          setLlmContent(res.data.llmContent || "");
          setEditedContent(res.data.llmContent || "");
          setFilename(res.data.filename || "board-paper.docx");
          setMetadata(res.data);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [open, reportId, executeRef]);

  const isPptx =
    metadata?.parameters?.outputFormat === "pptx" ||
    String(filename || "")
      .toLowerCase()
      .endsWith(".pptx");

  // Render docx-preview whenever base64 changes and we're in view mode (docx only — there is no
  // reliable inline .pptx renderer, so PowerPoint reports show a download card instead).
  useEffect(() => {
    if (isPptx) return;
    if (mode !== "view" || !docxBase64 || !previewNode) return;
    if (renderedBase64Ref.current === docxBase64) return;
    renderedBase64Ref.current = docxBase64;

    const container = previewNode;
    container.innerHTML = "";

    const arrayBuffer = base64ToArrayBuffer(docxBase64);
    import("docx-preview")
      .then(({ renderAsync }) =>
        renderAsync(arrayBuffer, container, undefined, {
          className: "docx-preview-wrapper",
          inWrapper: true,
          ignoreWidth: false,
          ignoreHeight: false,
          useBase64URL: true,
          renderHeaders: true,
          renderFooters: true,
          renderFootnotes: true,
        })
      )
      .catch((err) => {
        container.innerHTML = `<p style="padding:24px;color:#c62828">Failed to render document: ${err.message}</p>`;
      });
  }, [docxBase64, mode, isPptx, previewNode]);

  const switchMode = (next) => {
    setMode(next);
    if (next === "view") renderedBase64Ref.current = null; // force re-render
  };

  const handleSave = async () => {
    setSaving(true);
    setSaveError(null);
    try {
      const res = await executeRef.current(
        "PUT",
        `${protectedResources.apiTodoList.endpoint}/boardPaper/${reportId}/content`,
        { llmContent: editedContent }
      );
      if (!res?.success) throw new Error(res?.message || "Save failed.");
      setLlmContent(editedContent);
      // Re-fetch updated docx and switch to view
      const viewRes = await executeRef.current(
        "GET",
        `${protectedResources.apiTodoList.endpoint}/boardPaper/${reportId}/view`
      );
      if (viewRes?.success) {
        setDocxBase64(viewRes.data.docxBase64);
        renderedBase64Ref.current = null;
      }
      setMode("view");
    } catch (e) {
      setSaveError(String(e.message || e));
    } finally {
      setSaving(false);
    }
  };

  const handleDownload = () => {
    if (docxBase64) triggerDocxDownload(docxBase64, filename);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: { height: "92vh", maxHeight: "92vh", display: "flex", flexDirection: "column" },
      }}
    >
      {/* ── header ── */}
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          borderBottom: "1px solid rgba(0,0,0,0.12)",
          py: 1.5,
          px: 2.5,
        }}
      >
        <Box>
          <MDTypography variant="h6" fontWeight="bold" sx={{ color: "#52009b", lineHeight: 1.2 }}>
            Board Paper
          </MDTypography>
          {metadata && (
            <MDTypography variant="caption" color="text.secondary">
              {new Date(metadata.createdAt).toLocaleString()} · {metadata.generatedBy}
              {metadata.parameters?.length && ` · ${metadata.parameters.length}`}
            </MDTypography>
          )}
        </Box>

        <Box sx={{ display: "flex", gap: 0.5, alignItems: "center", mt: 0.5 }}>
          {/* View / Edit toggle */}
          <Box
            sx={{
              display: "flex",
              border: "1px solid rgba(82,0,155,0.35)",
              borderRadius: "6px",
              overflow: "hidden",
              mr: 1,
            }}
          >
            {["view", "edit"].map((m) => (
              <Box
                key={m}
                onClick={() => switchMode(m)}
                sx={{
                  px: 2,
                  py: 0.6,
                  cursor: "pointer",
                  bgcolor: mode === m ? "#52009b" : "transparent",
                  color: mode === m ? "#fff" : "#52009b",
                  fontSize: 13,
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  transition: "background 0.15s",
                  "&:hover": mode !== m ? { bgcolor: "rgba(82,0,155,0.06)" } : {},
                }}
              >
                {m === "view" ? (
                  <VisibilityIcon sx={{ fontSize: 15 }} />
                ) : (
                  <EditIcon sx={{ fontSize: 15 }} />
                )}
                {m.charAt(0).toUpperCase() + m.slice(1)}
              </Box>
            ))}
          </Box>

          {isAdmin && (
            <Tooltip title={`Download .${isPptx ? "pptx" : "docx"}`}>
              <span>
                <IconButton onClick={handleDownload} disabled={!docxBase64} size="small">
                  <DownloadIcon sx={{ color: "#52009b" }} />
                </IconButton>
              </span>
            </Tooltip>
          )}

          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      {/* ── body ── */}
      <DialogContent
        sx={{
          p: 0,
          flex: 1,
          overflow: "auto",
          bgcolor: mode === "view" ? "#e8e8e8" : "#fff",
          position: "relative",
        }}
      >
        {loading ? (
          <Box
            key="bp-loading"
            sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}
          >
            <CircularProgress sx={{ color: "#52009b" }} />
          </Box>
        ) : mode === "view" && isPptx ? (
          <Box
            key="bp-pptx"
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              gap: 2,
              p: 4,
              textAlign: "center",
            }}
          >
            <ArticleIcon sx={{ fontSize: 64, color: "#ad1457" }} />
            <MDTypography variant="h6" sx={{ color: "#52009b" }}>
              PowerPoint report
            </MDTypography>
            <MDTypography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
              PowerPoint decks can&apos;t be previewed inline. Download to open it, or switch to
              Edit to review and tweak the content.
            </MDTypography>
            <MDButton
              variant="contained"
              onClick={handleDownload}
              disabled={!docxBase64}
              startIcon={<DownloadIcon />}
              sx={{ bgcolor: "#52009b", color: "#fff", "&:hover": { bgcolor: "#3a0070" } }}
            >
              Download {filename}
            </MDButton>
          </Box>
        ) : mode === "view" ? (
          docxBase64 ? (
            <Box
              key="bp-docx-view"
              ref={setPreviewNode}
              sx={{
                minHeight: "100%",
                "& .docx-preview-wrapper": { background: "transparent" },
                "& .docx-wrapper": {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  py: 3,
                  gap: 2,
                },
                "& section.docx": {
                  background: "#fff",
                  boxShadow: "0 2px 12px rgba(0,0,0,0.15)",
                  borderRadius: "2px",
                },
              }}
            />
          ) : (
            <Box
              key="bp-unavailable"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <MDTypography variant="body2" color="text.secondary">
                Document not available.
              </MDTypography>
            </Box>
          )
        ) : (
          <Box
            key="bp-edit"
            sx={{ p: 2.5, height: "100%", display: "flex", flexDirection: "column" }}
          >
            {saveError && (
              <MDAlert color="error" sx={{ mb: 1.5 }} onClose={() => setSaveError(null)}>
                {saveError}
              </MDAlert>
            )}
            <MDTypography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1 }}>
              Edit the report below — use the toolbar for headings, bold, lists and links; the right
              pane previews the formatting live. Click &quot;Save &amp; Rebuild&quot; to regenerate
              the Word document.
            </MDTypography>
            <Box
              data-color-mode="light"
              sx={{
                flex: 1,
                minHeight: 0,
                overflow: "auto",
                "& .w-md-editor": { boxShadow: "none", border: "1px solid rgba(0,0,0,0.12)" },
              }}
            >
              <MDEditor
                value={editedContent}
                onChange={(v) => setEditedContent(v || "")}
                height={560}
                preview="live"
                visibleDragbar={false}
                textareaProps={{ spellCheck: true, placeholder: "Report content (markdown)…" }}
              />
            </Box>
          </Box>
        )}
      </DialogContent>

      {/* ── edit footer ── */}
      {mode === "edit" && (
        <DialogActions sx={{ borderTop: "1px solid rgba(0,0,0,0.12)", px: 2.5, py: 1.5, gap: 1 }}>
          <MDButton
            variant="text"
            onClick={() => {
              setEditedContent(llmContent);
              switchMode("view");
            }}
            disabled={saving}
          >
            Cancel
          </MDButton>
          <MDButton
            variant="contained"
            onClick={handleSave}
            disabled={saving || editedContent === llmContent}
            startIcon={
              saving ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : <SaveIcon />
            }
            sx={{ bgcolor: "#52009b", color: "#fff", "&:hover": { bgcolor: "#3a0070" } }}
          >
            {saving ? "Saving…" : "Save & Rebuild"}
          </MDButton>
        </DialogActions>
      )}
    </Dialog>
  );
}

// ─── Main page ────────────────────────────────────────────────────────────────

export default function BoardPaper() {
  const { execute } = useFetchWithMsal({ scopes: [siteData?.apiScopes] });
  const executeRef = useRef(execute);
  executeRef.current = execute;

  const { isRiskAdmin, role } = useCurrentUser();

  const [dialogOpen, setDialogOpen] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [reports, setReports] = useState([]);
  const [loadingList, setLoadingList] = useState(true);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);
  const [viewingId, setViewingId] = useState(null);

  const fetchReports = useCallback(() => {
    setLoadingList(true);
    executeRef
      .current("GET", `${protectedResources.apiTodoList.endpoint}/boardPaper/list`)
      .then((res) => setReports(Array.isArray(res?.data) ? res.data : []))
      .catch(() => setReports([]))
      .finally(() => setLoadingList(false));
  }, []);

  useEffect(() => {
    fetchReports();
  }, [fetchReports]);

  // Open the viewer when arriving with ?view=<reportId> (e.g. generated from the top-nav dialog).
  const location = useLocation();
  useEffect(() => {
    const v = new URLSearchParams(location.search).get("view");
    if (v) setViewingId(v);
  }, [location.search]);

  const handleGenerate = async (params) => {
    setGenerating(true);
    setError(null);
    try {
      const res = await executeRef.current(
        "POST",
        `${protectedResources.apiTodoList.endpoint}/boardPaper/generate`,
        params
      );
      if (!res?.success) throw new Error(res?.message || "Generation failed.");
      setDialogOpen(false);
      setSuccessMsg("Report generated. Click the row to open and review in the viewer.");
      fetchReports();
      setTimeout(() => setSuccessMsg(null), 7000);
    } catch (e) {
      setError(String(e.message || e));
    } finally {
      setGenerating(false);
    }
  };

  const handleDownload = async (reportId, e) => {
    e.stopPropagation();
    const res = await executeRef.current(
      "GET",
      `${protectedResources.apiTodoList.endpoint}/boardPaper/${reportId}/download`
    );
    if (res?.success) triggerDocxDownload(res.data.docxBase64, res.data.filename);
  };

  const handleDelete = async (reportId, e) => {
    e.stopPropagation();
    if (!window.confirm("Delete this report? This cannot be undone.")) return;
    await executeRef.current(
      "DELETE",
      `${protectedResources.apiTodoList.endpoint}/boardPaper/${reportId}`
    );
    fetchReports();
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3} px={3}>
        {/* Header */}
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 3 }}>
          <Box>
            <MDTypography variant="h5" fontWeight="bold" sx={{ color: "#52009b" }}>
              Board Paper
            </MDTypography>
          </Box>
          {role !== "VIEW" && (
            <MDButton
              variant="contained"
              startIcon={<ArticleIcon />}
              onClick={() => setDialogOpen(true)}
              sx={{ bgcolor: "#52009b", color: "#fff", "&:hover": { bgcolor: "#3a0070" }, ml: 2 }}
            >
              Generate Report
            </MDButton>
          )}
        </Box>

        {successMsg && (
          <MDAlert color="success" dismissible sx={{ mb: 2 }}>
            {successMsg}
          </MDAlert>
        )}
        {error && (
          <MDAlert color="error" dismissible sx={{ mb: 2 }} onClose={() => setError(null)}>
            {error}
          </MDAlert>
        )}

        {/* Report history */}
        <Card variant="outlined" sx={{ borderColor: "rgba(82,0,155,0.2)" }}>
          <CardContent>
            <MDTypography variant="subtitle2" fontWeight="bold" sx={{ mb: 2 }}>
              Report history
              <MDTypography
                component="span"
                variant="caption"
                color="text.secondary"
                sx={{ ml: 1, fontWeight: 400 }}
              >
                — click a row to open in the viewer
              </MDTypography>
            </MDTypography>

            {loadingList ? (
              <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                <CircularProgress sx={{ color: "#52009b" }} />
              </Box>
            ) : reports.length === 0 ? (
              <MDTypography variant="body2" color="text.secondary">
                No reports generated yet. Click &quot;Generate Board Paper&quot; to create your
                first report.
              </MDTypography>
            ) : (
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Generated</TableCell>
                    <TableCell>By</TableCell>
                    <TableCell>Report Type</TableCell>
                    <TableCell>Format</TableCell>
                    <TableCell>Length</TableCell>
                    <TableCell>Period</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell align="right">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reports.map((r) => {
                    const rid = r.id || r._id;
                    const clickable = r.status === "complete";
                    return (
                      <TableRow
                        key={rid}
                        onClick={() => clickable && setViewingId(rid)}
                        sx={{
                          cursor: clickable ? "pointer" : "default",
                          "&:hover": clickable ? { bgcolor: "rgba(82,0,155,0.04)" } : {},
                        }}
                      >
                        <TableCell sx={{ whiteSpace: "nowrap" }}>
                          {new Date(r.createdAt).toLocaleString()}
                        </TableCell>
                        <TableCell
                          sx={{ maxWidth: 160, overflow: "hidden", textOverflow: "ellipsis" }}
                        >
                          {r.generatedBy}
                        </TableCell>
                        <TableCell>
                          {REPORT_TYPE_LABELS[r.parameters?.reportType] || "Board Paper"}
                        </TableCell>
                        <TableCell>
                          <Chip
                            size="small"
                            label={
                              (r.parameters?.outputFormat || "docx") === "pptx" ? "PPTX" : "DOCX"
                            }
                            sx={{
                              bgcolor:
                                (r.parameters?.outputFormat || "docx") === "pptx"
                                  ? "#fce4ec"
                                  : "#ede7f6",
                              color:
                                (r.parameters?.outputFormat || "docx") === "pptx"
                                  ? "#ad1457"
                                  : "#52009b",
                              fontWeight: 700,
                              fontSize: "0.65rem",
                            }}
                          />
                        </TableCell>
                        <TableCell>{r.parameters?.length || "—"}</TableCell>
                        <TableCell>{r.parameters?.dateMode || "current"}</TableCell>
                        <TableCell>
                          <Chip
                            size="small"
                            label={r.status}
                            sx={{
                              bgcolor:
                                r.status === "complete"
                                  ? "#e8f5e9"
                                  : r.status === "error"
                                  ? "#ffebee"
                                  : "#fff3e0",
                              color:
                                r.status === "complete"
                                  ? "#2e7d32"
                                  : r.status === "error"
                                  ? "#c62828"
                                  : "#e65100",
                            }}
                          />
                        </TableCell>
                        <TableCell align="right">
                          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 0.5 }}>
                            {clickable && isRiskAdmin && (
                              <Tooltip title={`Download .${r.parameters?.outputFormat || "docx"}`}>
                                <IconButton size="small" onClick={(e) => handleDownload(rid, e)}>
                                  <DownloadIcon fontSize="small" sx={{ color: "#52009b" }} />
                                </IconButton>
                              </Tooltip>
                            )}
                            {isRiskAdmin && (
                              <Tooltip title="Delete report">
                                <IconButton size="small" onClick={(e) => handleDelete(rid, e)}>
                                  <DeleteIcon fontSize="small" sx={{ color: "#d32f2f" }} />
                                </IconButton>
                              </Tooltip>
                            )}
                          </Box>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            )}
          </CardContent>
        </Card>
      </MDBox>

      <GenerateReportDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onGenerated={(data) => {
          fetchReports();
          // Open the viewer straight away for the new report (no need to find it in the table).
          if (data?.reportId) setViewingId(data.reportId);
          setSuccessMsg("Report generated.");
          setTimeout(() => setSuccessMsg(null), 5000);
        }}
      />

      {/* key by viewingId so each open (even the same report reopened) gets a fresh mount —
          prevents stale docxBase64 / renderedBase64Ref state from a prior open bleeding through. */}
      <ViewModal
        key={viewingId || "closed"}
        open={Boolean(viewingId)}
        reportId={viewingId}
        onClose={() => setViewingId(null)}
        executeRef={executeRef}
        isAdmin={isRiskAdmin}
      />
    </DashboardLayout>
  );
}
